import TimelineStatusStore from '../stores/TimelineStatusStore';
const TimelineStatusDependency = {
  stores: [TimelineStatusStore],
  deref: () => {
    return TimelineStatusStore.get('timelineStatus');
  }
};
export default TimelineStatusDependency;